import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { TrendingUp, TrendingDown, AlertTriangle, BarChart3, Share2, Calendar, MapPin, Euro, Fuel, Banknote, Download, Truck, Ship, Plane, Building, Target, Users, Package, Clock, Leaf, Network, DollarSign, Zap, Brain, Anchor, Battery, Globe, ShoppingCart, Crown, Bot } from "lucide-react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
import { useLanguage } from "@/contexts/LanguageContext";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { Link } from "react-router-dom";
const Index = () => {
  const {
    t
  } = useLanguage();

  // Sample data for charts with translated labels
  const freightRatesData = [{
    month: t('month.jul'),
    rate: 2850
  }, {
    month: t('month.aug'),
    rate: 2650
  }, {
    month: t('month.sep'),
    rate: 2400
  }, {
    month: t('month.oct'),
    rate: 2200
  }];
  const inflationData = [
  // 2024 Data
  {
    month: t('month.jan') + ' 2024',
    netherlands: 3.1,
    uk: 4.0,
    poland: 2.9,
    slovakia: 2.8,
    france: 2.9,
    germany: 2.9,
    spain: 3.1,
    italy: 0.8,
    sweden: 3.4
  }, {
    month: t('month.feb') + ' 2024',
    netherlands: 2.8,
    uk: 3.4,
    poland: 2.8,
    slovakia: 2.7,
    france: 2.8,
    germany: 2.5,
    spain: 2.8,
    italy: 0.9,
    sweden: 3.1
  }, {
    month: t('month.mar') + ' 2024',
    netherlands: 2.7,
    uk: 3.2,
    poland: 2.0,
    slovakia: 2.9,
    france: 2.4,
    germany: 2.2,
    spain: 3.2,
    italy: 1.2,
    sweden: 2.9
  }, {
    month: t('month.apr') + ' 2024',
    netherlands: 2.6,
    uk: 2.3,
    poland: 2.5,
    slovakia: 2.8,
    france: 2.4,
    germany: 2.4,
    spain: 3.3,
    italy: 0.8,
    sweden: 2.2
  }, {
    month: t('month.may') + ' 2024',
    netherlands: 2.8,
    uk: 2.0,
    poland: 2.8,
    slovakia: 2.9,
    france: 2.6,
    germany: 2.4,
    spain: 3.6,
    italy: 0.8,
    sweden: 2.3
  }, {
    month: t('month.jun') + ' 2024',
    netherlands: 3.2,
    uk: 2.0,
    poland: 2.6,
    slovakia: 2.7,
    france: 2.5,
    germany: 2.2,
    spain: 3.5,
    italy: 0.9,
    sweden: 2.6
  }, {
    month: t('month.jul') + ' 2024',
    netherlands: 3.7,
    uk: 2.2,
    poland: 4.2,
    slovakia: 2.8,
    france: 2.6,
    germany: 2.3,
    spain: 2.8,
    italy: 1.3,
    sweden: 2.6
  }, {
    month: t('month.aug') + ' 2024',
    netherlands: 3.3,
    uk: 2.2,
    poland: 4.3,
    slovakia: 2.8,
    france: 2.2,
    germany: 1.9,
    spain: 2.4,
    italy: 1.1,
    sweden: 2.2
  }, {
    month: t('month.sep') + ' 2024',
    netherlands: 3.3,
    uk: 1.7,
    poland: 4.9,
    slovakia: 2.8,
    france: 1.7,
    germany: 1.6,
    spain: 1.5,
    italy: 0.7,
    sweden: 1.1
  }, {
    month: t('month.oct') + ' 2024',
    netherlands: 3.2,
    uk: 1.7,
    poland: 5.0,
    slovakia: 2.8,
    france: 2.0,
    germany: 2.0,
    spain: 1.8,
    italy: 0.9,
    sweden: 1.6
  }, {
    month: t('month.nov') + ' 2024',
    netherlands: 3.8,
    uk: 2.3,
    poland: 4.7,
    slovakia: 2.9,
    france: 2.3,
    germany: 2.2,
    spain: 2.4,
    italy: 1.4,
    sweden: 1.8
  }, {
    month: t('month.dec') + ' 2024',
    netherlands: 4.0,
    uk: 2.5,
    poland: 4.8,
    slovakia: 3.0,
    france: 2.4,
    germany: 2.6,
    spain: 2.8,
    italy: 1.3,
    sweden: 2.2
  },
  // 2025 Data
  {
    month: t('month.jan') + ' 2025',
    netherlands: 3.6,
    uk: 2.9,
    poland: 4.6,
    slovakia: 3.2,
    france: 2.4,
    germany: 2.3,
    spain: 2.4,
    italy: 1.2,
    sweden: 2.0
  }, {
    month: t('month.feb') + ' 2025',
    netherlands: 3.1,
    uk: 3.4,
    poland: 3.7,
    slovakia: 3.1,
    france: 2.6,
    germany: 2.7,
    spain: 2.8,
    italy: 1.0,
    sweden: 1.8
  }, {
    month: t('month.mar') + ' 2025',
    netherlands: 2.9,
    uk: 3.2,
    poland: 2.0,
    slovakia: 2.8,
    france: 2.4,
    germany: 2.2,
    spain: 3.1,
    italy: 1.1,
    sweden: 2.1
  }, {
    month: t('month.apr') + ' 2025',
    netherlands: 2.7,
    uk: 2.3,
    poland: 2.4,
    slovakia: 2.6,
    france: 2.4,
    germany: 2.1,
    spain: 3.3,
    italy: 0.8,
    sweden: 1.9
  }, {
    month: t('month.may') + ' 2025',
    netherlands: 2.8,
    uk: 2.0,
    poland: 2.7,
    slovakia: 2.7,
    france: 2.6,
    germany: 2.4,
    spain: 3.6,
    italy: 0.8,
    sweden: 2.2
  }, {
    month: t('month.jun') + ' 2025',
    netherlands: 3.0,
    uk: 2.0,
    poland: 2.5,
    slovakia: 2.5,
    france: 2.5,
    germany: 2.2,
    spain: 3.4,
    italy: 0.9,
    sweden: 2.4
  }, {
    month: t('month.jul') + ' 2025',
    netherlands: 3.2,
    uk: 2.2,
    poland: 4.0,
    slovakia: 2.6,
    france: 2.4,
    germany: 2.3,
    spain: 2.6,
    italy: 1.2,
    sweden: 2.3
  }, {
    month: t('month.aug') + ' 2025',
    netherlands: 2.8,
    uk: 2.2,
    poland: 4.1,
    slovakia: 2.6,
    france: 2.2,
    germany: 1.9,
    spain: 2.2,
    italy: 1.0,
    sweden: 2.0
  }, {
    month: t('month.sep') + ' 2025',
    netherlands: 2.4,
    uk: 1.7,
    poland: 4.7,
    slovakia: 2.6,
    france: 2.0,
    germany: 1.6,
    spain: 1.7,
    italy: 0.7,
    sweden: 1.3
  }, {
    month: t('month.oct') + ' 2025',
    netherlands: 2.6,
    uk: 1.7,
    poland: 4.8,
    slovakia: 2.7,
    france: 2.1,
    germany: 2.0,
    spain: 1.8,
    italy: 0.9,
    sweden: 1.5
  }];
  const dieselPricesData = [
  // 2024 Data
  {
    month: t('month.jan') + ' 2024',
    netherlands: 1.54,
    germany: 1.50,
    uk: 1.48,
    poland: 1.35,
    slovakia: 1.42
  }, {
    month: t('month.feb') + ' 2024',
    netherlands: 1.53,
    germany: 1.49,
    uk: 1.47,
    poland: 1.34,
    slovakia: 1.41
  }, {
    month: t('month.mar') + ' 2024',
    netherlands: 1.55,
    germany: 1.51,
    uk: 1.49,
    poland: 1.36,
    slovakia: 1.43
  }, {
    month: t('month.apr') + ' 2024',
    netherlands: 1.56,
    germany: 1.52,
    uk: 1.50,
    poland: 1.37,
    slovakia: 1.44
  }, {
    month: t('month.may') + ' 2024',
    netherlands: 1.57,
    germany: 1.53,
    uk: 1.51,
    poland: 1.38,
    slovakia: 1.45
  }, {
    month: t('month.jun') + ' 2024',
    netherlands: 1.58,
    germany: 1.54,
    uk: 1.52,
    poland: 1.39,
    slovakia: 1.46
  }, {
    month: t('month.jul') + ' 2024',
    netherlands: 1.59,
    germany: 1.55,
    uk: 1.53,
    poland: 1.40,
    slovakia: 1.47
  }, {
    month: t('month.aug') + ' 2024',
    netherlands: 1.60,
    germany: 1.56,
    uk: 1.54,
    poland: 1.41,
    slovakia: 1.48
  }, {
    month: t('month.sep') + ' 2024',
    netherlands: 1.58,
    germany: 1.54,
    uk: 1.52,
    poland: 1.39,
    slovakia: 1.46
  }, {
    month: t('month.oct') + ' 2024',
    netherlands: 1.58,
    germany: 1.54,
    uk: 1.52,
    poland: 1.39,
    slovakia: 1.46
  }, {
    month: t('month.nov') + ' 2024',
    netherlands: 1.60,
    germany: 1.56,
    uk: 1.54,
    poland: 1.41,
    slovakia: 1.48
  }, {
    month: t('month.dec') + ' 2024',
    netherlands: 1.61,
    germany: 1.57,
    uk: 1.55,
    poland: 1.42,
    slovakia: 1.49
  },
  // 2025 Data
  {
    month: t('month.jan') + ' 2025',
    netherlands: 1.62,
    germany: 1.58,
    uk: 1.56,
    poland: 1.43,
    slovakia: 1.50
  }, {
    month: t('month.feb') + ' 2025',
    netherlands: 1.63,
    germany: 1.59,
    uk: 1.57,
    poland: 1.44,
    slovakia: 1.51
  }, {
    month: t('month.mar') + ' 2025',
    netherlands: 1.64,
    germany: 1.60,
    uk: 1.58,
    poland: 1.45,
    slovakia: 1.52
  }, {
    month: t('month.apr') + ' 2025',
    netherlands: 1.64,
    germany: 1.60,
    uk: 1.58,
    poland: 1.45,
    slovakia: 1.52
  }, {
    month: t('month.may') + ' 2025',
    netherlands: 1.65,
    germany: 1.61,
    uk: 1.59,
    poland: 1.46,
    slovakia: 1.53
  }, {
    month: t('month.jun') + ' 2025',
    netherlands: 1.65,
    germany: 1.61,
    uk: 1.59,
    poland: 1.46,
    slovakia: 1.53
  }, {
    month: t('month.jul') + ' 2025',
    netherlands: 1.64,
    germany: 1.60,
    uk: 1.58,
    poland: 1.45,
    slovakia: 1.52
  }, {
    month: t('month.aug') + ' 2025',
    netherlands: 1.63,
    germany: 1.59,
    uk: 1.57,
    poland: 1.44,
    slovakia: 1.51
  }, {
    month: t('month.sep') + ' 2025',
    netherlands: 1.64,
    germany: 1.60,
    uk: 1.58,
    poland: 1.45,
    slovakia: 1.52
  }, {
    month: t('month.oct') + ' 2025',
    netherlands: 1.65,
    germany: 1.61,
    uk: 1.59,
    poland: 1.46,
    slovakia: 1.53
  }];
  const minimumWageData = [{
    country: 'Netherlands',
    wage: 12.83,
    color: '#FF6B35'
  }, {
    country: 'Germany',
    wage: 12.41,
    color: '#FFD23F'
  }, {
    country: 'United Kingdom',
    wage: 11.44,
    color: '#004E89'
  }, {
    country: 'Poland',
    wage: 4.30,
    color: '#DC143C'
  }, {
    country: 'Slovakia',
    wage: 4.50,
    color: '#9A031E'
  }];

  // PDF Generation Function
  const generatePDF = () => {
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;
    const currentDate = new Date().toLocaleDateString();
    const pdfContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>LogiSense Portal Report - ${currentDate}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; color: #333; }
          .header { text-align: center; border-bottom: 2px solid #3b82f6; padding-bottom: 20px; margin-bottom: 30px; }
          .header h1 { color: #3b82f6; margin: 0; font-size: 28px; }
          .header p { color: #666; margin: 5px 0; }
          .section { margin-bottom: 30px; page-break-inside: avoid; }
          .section h2 { color: #1f2937; border-left: 4px solid #3b82f6; padding-left: 15px; font-size: 20px; }
          .section h3 { color: #374151; font-size: 16px; margin-top: 20px; }
          .card { border: 1px solid #e5e7eb; border-radius: 8px; padding: 15px; margin: 15px 0; background: #f9fafb; }
          .badge { display: inline-block; padding: 4px 8px; border-radius: 4px; font-size: 12px; font-weight: bold; }
          .badge-red { background: #fee2e2; color: #dc2626; }
          .badge-orange { background: #fed7aa; color: #ea580c; }
          .badge-green { background: #dcfce7; color: #16a34a; }
          .badge-blue { background: #dbeafe; color: #2563eb; }
          .stats { display: flex; justify-content: space-between; margin: 10px 0; }
          .stat { text-align: center; }
          .stat-value { font-size: 18px; font-weight: bold; color: #3b82f6; }
          .stat-label { font-size: 12px; color: #666; }
          .insights { background: #f0f9ff; border-left: 4px solid #0ea5e9; padding: 15px; margin: 15px 0; }
          .insights h4 { margin: 0 0 10px 0; color: #0c4a6e; }
          .insights ul { margin: 0; padding-left: 20px; }
          .insights li { margin: 5px 0; color: #0c4a6e; }
          @media print { body { margin: 0; } .section { page-break-inside: avoid; } }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>LogiSense Portal</h1>
          <p>European Logistics News & Risk Intelligence</p>
          <p>Report Generated: ${currentDate}</p>
        </div>

        <div class="section">
          <h2>Latest Risk Sensing</h2>
          
          <div class="card">
            <h3><span class="badge badge-red">HIGH RISK</span> Rotterdam and Antwerp Port Still Congested After End of Strikes</h3>
            <p><strong>Date:</strong> Oct 5-18, 2025 | <strong>Status:</strong> RECOVERING</p>
            <p>While strikes have officially ended in both Rotterdam and Antwerp ports, significant congestion persists with vessel backlogs continuing to impact European logistics operations.</p>
            <div class="stats">
              <div class="stat">
                <div class="stat-value">90+</div>
                <div class="stat-label">Ships Waiting (Peak)</div>
              </div>
              <div class="stat">
                <div class="stat-value">14 days</div>
                <div class="stat-label">Strike Duration</div>
              </div>
              <div class="stat">
                <div class="stat-value">Ongoing</div>
                <div class="stat-label">Recovery Status</div>
              </div>
            </div>
          </div>

          <div class="card">
            <h3><span class="badge badge-red">HIGH RISK</span> COSCO Chartered Boxship Caught in China Port Fee Dispute</h3>
            <p><strong>Date:</strong> October 28, 2025 | <strong>Status:</strong> ACTIVE</p>
            <p>A COSCO-operated containership skipped China calls after becoming subject to new port fees targeting US-linked vessels, demonstrating strict enforcement even against state-owned companies.</p>
            <div class="stats">
              <div class="stat">
                <div class="stat-value">Halley</div>
                <div class="stat-label">Vessel (2,550 TEU)</div>
              </div>
              <div class="stat">
                <div class="stat-value">Seeking Exemption</div>
                <div class="stat-label">Status</div>
              </div>
              <div class="stat">
                <div class="stat-value">High Risk</div>
                <div class="stat-label">Impact Level</div>
              </div>
            </div>
          </div>

          <div class="card">
            <h3><span class="badge badge-red">HIGH RISK</span> AWS Outage Disrupts Global Supply Chains</h3>
            <p><strong>Date:</strong> October 25, 2025 | <strong>Status:</strong> RESOLVED</p>
            <p>A major Amazon Web Services outage lasting over 4 hours caused widespread disruptions to supply chain management systems across Europe and North America.</p>
            <div class="stats">
              <div class="stat">
                <div class="stat-value">4.2 hours</div>
                <div class="stat-label">Total Duration</div>
              </div>
              <div class="stat">
                <div class="stat-value">$2.3B</div>
                <div class="stat-label">Economic Impact</div>
              </div>
              <div class="stat">
                <div class="stat-value">98%</div>
                <div class="stat-label">Recovery Rate</div>
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <h2>Industry Highlights</h2>
          
          <div class="card">
            <h3><span class="badge badge-red">DECLINING</span> European Logistics Firms Face Impact from Falling Freight Rates</h3>
            <p><strong>Date:</strong> October 15, 2025</p>
            <p>European shipping and logistics firms are under pressure as ocean container rates plunge to their lowest since January 2024, driven by industry oversupply and weaker demand following new U.S. tariffs.</p>
          </div>

          <div class="card">
            <h3><span class="badge badge-green">EXPANSION</span> FS Logistix Takes Over Train Connection Between Antwerp and Milan</h3>
            <p><strong>Date:</strong> October 18, 2025</p>
            <p>Italy's FS Logistix has taken over the Antwerp-Milan intermodal train service, operating five times weekly and removing approximately 13,000 trucks from European roads annually.</p>
            <div class="stats">
              <div class="stat">
                <div class="stat-value">5</div>
                <div class="stat-label">Weekly Connections</div>
              </div>
              <div class="stat">
                <div class="stat-value">13,000</div>
                <div class="stat-label">Trucks Removed/Year</div>
              </div>
            </div>
          </div>

          <div class="card">
            <h3><span class="badge badge-blue">NEW POLICY</span> Europe's New Carbon Market for Buildings and Road Transport</h3>
            <p><strong>Date:</strong> October 22, 2025</p>
            <p>The EU's new Emissions Trading System (ETS2) will cover CO2 emissions from buildings and road transport starting 2027, complementing existing climate policies to achieve 2050 neutrality goals.</p>
            <div class="stats">
              <div class="stat">
                <div class="stat-value">2027</div>
                <div class="stat-label">Launch Date</div>
              </div>
              <div class="stat">
                <div class="stat-value">42%</div>
                <div class="stat-label">Emission Reduction by 2030</div>
              </div>
            </div>
          </div>
        </div>



        <div style="text-align: center; margin-top: 40px; padding-top: 20px; border-top: 1px solid #e5e7eb; color: #666; font-size: 12px;">
          <p>Generated from LogiSense Portal | ${currentDate}</p>
          <p>For the latest updates, visit: https://8wjtubsrmt.skywork.website</p>
        </div>
      </body>
      </html>
    `;
    printWindow.document.write(pdfContent);
    printWindow.document.close();

    // Wait for content to load, then trigger print
    setTimeout(() => {
      printWindow.print();
    }, 500);
  };
  const ShareButton = ({
    title
  }: {
    title: string;
  }) => <Button variant="outline" size="sm" className="ml-auto">
      <Share2 className="h-4 w-4 mr-2" />
      {t('common.share')}
    </Button>;
  return <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">


      <div className="container mx-auto px-6 py-8 space-y-12">
        {/* WK 43 Industry Highlights */}
        <section id="industry-highlights">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center">
              <BarChart3 className="h-8 w-8 text-blue-600 mr-3" />
              <h2 className="text-3xl font-bold text-gray-900">{t('industry.title')}</h2>
            </div>
            <LanguageSwitcher />
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">

            {/* DHL Black Friday Article */}
            <Card className="hover:shadow-lg transition-shadow">
              <div className="relative h-48 overflow-hidden rounded-t-lg">
                <img src="https://imgs.newseditor.aws.kuehne-nagel.cloud/2b1af638-1cb1-47ea-a4b3-15d6eb3dfdac.jpg" alt="Supply chain diversification and business strategy" className="w-full h-[192px] object-cover" />
                <Badge className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent text-primary-foreground hover:bg-primary/80 absolute top-4 left-4 bg-[rgb(59,130,246)]">
                  <Ship className="h-3 w-3 mr-1" />
                  {t('article.warehouseai.badge')}
                </Badge>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">{t('article.warehouseai.title')}</CardTitle>
                <CardDescription className="flex items-center text-sm">
                  <Calendar className="h-4 w-4 mr-1" />
                  {t('article.warehouseai.date')}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">
                  {t('article.warehouseai.summary')}
                </p>
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Maersk Test Transit:</span>
                    <span className="font-semibold text-blue-600">6,500 TEU</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">CMA CGM Resumption:</span>
                    <span className="font-semibold text-green-600">Jan 18</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Full Suez Return:</span>
                    <span className="font-semibold text-orange-600">Q2 2026</span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <Badge variant="secondary">{t('article.warehouseai.badge')}</Badge>
                  <div className="flex space-x-2">
                    <Button variant="outline" size="sm" onClick={() => window.location.hash = '/article/warehouse-ai'}>
                      {t('common.readMore')}
                    </Button>
                    <ShareButton title="Red Sea Reopenings CMA CGM Article" />
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Chinese E-commerce Article */}
            <Card className="hover:shadow-lg transition-shadow">
              <div className="relative h-48 overflow-hidden rounded-t-lg">
                <img src="https://imgs.newseditor.aws.kuehne-nagel.cloud/9c5e4638-a813-497a-b028-cfdd8fbe124d.jpg" alt="European logistics strike disruption and coordination" className="w-full h-[192px] object-cover" />
                <Badge className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent text-primary-foreground hover:bg-primary/80 absolute top-4 left-4 bg-[rgb(59,130,246)]">
                  <Anchor className="h-3 w-3 mr-1" />
                  {t('article.chineseecom.badge')}
                </Badge>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">{t('article.chineseecom.title')}</CardTitle>
                <CardDescription className="flex items-center text-sm">
                  <Calendar className="h-4 w-4 mr-1" />
                  {t('article.chineseecom.date')}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">
                  {t('article.chineseecom.summary')}
                </p>
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Service Launch:</span>
                    <span className="font-semibold text-blue-600">April 2026</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Trade Lanes:</span>
                    <span className="font-semibold text-green-600">3 Routes</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Route Strategy:</span>
                    <span className="font-semibold text-orange-600">Cape Route</span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <Badge variant="secondary">{t('article.chineseecom.badge')}</Badge>
                  <div className="flex space-x-2">
                    <Button variant="outline" size="sm" onClick={() => window.location.hash = '/article/chinese-ecommerce'}>
                      {t('common.readMore')}
                    </Button>
                    <ShareButton title="ONE Premier Alliance 2026 Service Article" />
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Europe Logistics Market Article */}
            <Card className="hover:shadow-lg transition-shadow">
              <div className="relative h-48 overflow-hidden rounded-t-lg">
                <img src="https://d1dcnte8mfzkpv.cloudfront.net/uploads/2024/09/1b8bd9dfdeec192713b40e1d93d1.jpg" alt="European energy crisis impact on logistics operations" className="w-full h-[192px] object-cover" />
                <Badge className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent text-primary-foreground hover:bg-primary/80 absolute top-4 left-4 bg-[rgb(34,197,94)]">
                  <Truck className="h-3 w-3 mr-1" />
                  {t('article.europelogistics.badge')}
                </Badge>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">{t('article.europelogistics.title')}</CardTitle>
                <CardDescription className="flex items-center text-sm">
                  <Calendar className="h-4 w-4 mr-1" />
                  {t('article.europelogistics.date')}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">
                  {t('article.europelogistics.summary')}
                </p>
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Market Decline:</span>
                    <span className="font-semibold text-red-600">16%</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Electric Trucks:</span>
                    <span className="font-semibold text-blue-600">3.8%</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Market Value:</span>
                    <span className="font-semibold text-green-600">€254.57B</span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <Badge variant="secondary">{t('article.europelogistics.badge')}</Badge>
                  <div className="flex space-x-2">
                    <Button variant="outline" size="sm" onClick={() => window.location.hash = '/article/europe-logistics'}>
                      {t('common.readMore')}
                    </Button>
                    <ShareButton title="European Truck Market Overview Article" />
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Peak Season Article */}
            <Card className="hover:shadow-lg transition-shadow">
              <div className="relative h-48 overflow-hidden rounded-t-lg">
                <img src="https://imgs.newseditor.aws.kuehne-nagel.cloud/85451054-9b43-4913-8418-79397aa997d8.jpg" alt="European e-commerce adoption regional variations" className="w-full h-[192px] object-cover" />
                <Badge className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent text-primary-foreground hover:bg-primary/80 absolute top-4 left-4 bg-[rgb(34,197,94)]">
                  <Globe className="h-3 w-3 mr-1" />
                  {t('article.jdeurope.badge')}
                </Badge>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">{t('article.jdeurope.title')}</CardTitle>
                <CardDescription className="flex items-center text-sm">
                  <Calendar className="h-4 w-4 mr-1" />
                  {t('article.jdeurope.date')}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">
                  {t('article.jdeurope.summary')}
                </p>
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Emerging Growth:</span>
                    <span className="font-semibold text-green-600">Exceeds US</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Energy Decline:</span>
                    <span className="font-semibold text-orange-600">12%</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Young Population:</span>
                    <span className="font-semibold text-blue-600">32%</span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <Badge variant="secondary">{t('article.jdeurope.badge')}</Badge>
                  <div className="flex space-x-2">
                    <Button variant="outline" size="sm" onClick={() => window.location.hash = '/article/jd-europe'}>
                      {t('common.readMore')}
                    </Button>
                    <ShareButton title="Emerging Economies Global Trade Article" />
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Air Freight Article */}
            <Card className="hover:shadow-lg transition-shadow">
              <div className="relative h-48 overflow-hidden rounded-t-lg">
                <img src="https://www.maersk.com/~/media_sc9/maersk/insights/resilience/2025/12/man-and-woman-in-front-of-monitor_1024x576.jpg?w=1056&hash=C6F088BF1E7051DAC02E71ACDD7C6CAA" alt="GLS DPD parcel locker collaboration in Hungary" className="w-full h-[192px] object-cover" />
              <Badge className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent text-primary-foreground hover:bg-primary/80 absolute top-4 left-4 bg-[rgb(147,51,234)]">
                <Network className="h-3 w-3 mr-1" />
                {t('article.airfreight.badge')}
              </Badge>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">{t('article.airfreight.title')}</CardTitle>
                <CardDescription className="flex items-center text-sm">
                  <Calendar className="h-4 w-4 mr-1" />
                  {t('article.airfreight.date')}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">
                  {t('article.airfreight.summary')}
                </p>
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Revenue Loss:</span>
                    <span className="font-semibold text-red-600">3.6%</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Frontrunners Loss:</span>
                    <span className="font-semibold text-green-600">&lt;1%</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Collaboration Gap:</span>
                    <span className="font-semibold text-orange-600">31%</span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <Badge variant="secondary">{t('article.airfreight.badge')}</Badge>
                  <div className="flex space-x-2">
                    <Button variant="outline" size="sm" onClick={() => window.location.hash = '/article/air-freight'}>
                      {t('common.readMore')}
                    </Button>
                    <ShareButton title="Tech Supply Chain Resilience Article" />
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Suez Canal Article */}
            <Card className="hover:shadow-lg transition-shadow">
              <div className="relative h-48 overflow-hidden rounded-t-lg">
                <img src="https://www.dhl.com/content/dam/dhl/global/delivered/images/social-share-1200x630/d157-dl-business-logistics.jpg" alt="Siemens electric HGV logistics operations" className="w-full h-[192px] object-cover" />
                <Badge className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent text-primary-foreground hover:bg-primary/80 absolute top-4 left-4 bg-[rgb(59,130,246)]">
                  <Brain className="h-3 w-3 mr-1" />
                  {t('article.suezcanal.badge')}
                </Badge>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">{t('article.suezcanal.title')}</CardTitle>
                <CardDescription className="flex items-center text-sm">
                  <Calendar className="h-4 w-4 mr-1" />
                  {t('article.suezcanal.date')}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">
                  {t('article.suezcanal.summary')}
                </p>
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">AI Adoption Rate:</span>
                    <span className="font-semibold text-blue-600">73%</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">ROI Achievement:</span>
                    <span className="font-semibold text-green-600">65%</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Efficiency Gains:</span>
                    <span className="font-semibold text-purple-600">25%</span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <Badge variant="secondary">{t('article.suezcanal.badge')}</Badge>
                  <div className="flex space-x-2">
                    <Button variant="outline" size="sm" onClick={() => window.location.hash = '/article/suez-canal'}>
                      {t('common.readMore')}
                    </Button>
                    <ShareButton title="AI in Logistics Technology Article" />
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Prologis 2026 Supply Chain Trends Article */}



          </div>
        </section>



        {/* Latest Risk Sensing */}
        

        <Separator />




      </div>
      {/* Footer */}
      <footer className="bg-blue-900 text-white py-8 mt-12">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div>
              <h3 className="text-xl font-bold mb-2">{t('footer.title')}</h3>
              <p className="text-blue-200">{t('footer.subtitle')}</p>
            </div>
            <div className="mt-4 md:mt-0">
              <p className="text-blue-200 text-sm">
                {t('footer.updated')}
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>;
};
export default Index;